import { SelfExcludedComponent } from './SelfExcludedComponent';
import { withMyAccountTranslate } from '../../hoc';

export var SelfExcluded = withMyAccountTranslate(SelfExcludedComponent);